export default __webpack_public_path__ + "static/media/safari-logo.d887b238.png";